export class Niveau {
    id: number;
    niveau: string;

    public constructor(init?: Partial<Niveau>) {
      Object.assign(this, init);
    }
  }
